const formatoFecha = (f) => {
  // Convierte un texto de la forma 2017/01/10 a la forma
  return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
};

export { formatoFecha };
